<template>
  <div class="pos-schedule-container overflow-y pt-5">
    <div class="posUserCollection-title">
      <h3>Collection Summary</h3>
    </div>
    <button @click="closeModalSection()" class="btn-modal-close">
      &times;
    </button>
    <div class="row w-100">
      <!-- FROM DATE -->
      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="from_date"
                @click="from_date = ''"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="from_date"
                name="fdate1"
                id="fdate1"
                typeable
                v-validate="'required'"
                :disabled="dateDisable"
                @input="onChangeDate()"
                v-b-tooltip.hover
                :title="dateDisable ? `Showing Current Shift` : 'From Date'"
              ></Datepicker>
              <label :class="from_date ? 'active' : ''">From Date</label>
            </div>
          </div>
        </div>
      </div>

      <!-- TO DATE -->
      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="to_date"
                @click="to_date = ''"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="to_date"
                name="tdate1"
                id="tdate1"
                typeable
                :disabled="dateDisable"
                @input="onChangeDate()"
                v-b-tooltip.hover
                :title="dateDisable ? `Showing Current Shift` : 'To Date'"
              ></Datepicker>
              <label :class="to_date ? 'active' : ''">To Date</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-xl-4 align-self-center">
        <div class="d-flex align-items-center mb-4">
          <span>{{ "Current Shift Collection" }}</span>
          <b-form-checkbox
            class="ml-3 mt-2"
            v-model="show_current_shift_collection"
            unchecked-value="N"
            value="Y"
            switch
            @change="OnSwitchChange($event)"
          ></b-form-checkbox>
        </div>
      </div>
    </div>
    <div
      class="pos-user-collection-wrapper"
      v-if="CollectionData && CollectionData.length > 0"
    >
      <div class="userInfo mb-4">
        <div>User: {{ FinalTotal.user_name }}</div>
      </div>
      <div>Cash Summary</div>
      <header class="pos-schedule-header">
        <div
          class="col-lg-3 border-right h-100 d-flex align-items-center justify-content-start"
        >
          <strong>Payment Mode</strong>
        </div>
        <div class="col-lg-9">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="row schedule-header-titles">
                <div class="col-4 text-right">
                  <strong>Sale</strong>
                </div>
                <div class="col-4 text-right">
                  <strong>Refunded</strong>
                </div>
                <div class="col-4 text-right">
                  <strong>Total</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div class="row pos-user-collection mb-5">
        <div
          v-for="(data, dataIndex) in CollectionData"
          :key="dataIndex"
          v-if="data.payment_mode_id == 1"
          :class="[
            'col-12 row',
            CollectionData.length - 1 !== dataIndex ? 'border-bottom' : '',
          ]"
        >
          <div
            class="col-lg-3 border-right h-100 d-flex align-items-center justify-content-start"
          >
            <strong>{{ data.payment_mode_name }}</strong>
          </div>
          <div class="col-lg-9">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <div class="row schedule-header-titles">
                  <div class="col-4 text-right">
                    <strong>{{ currFormat(data.total) || 0 }}</strong>
                  </div>
                  <div class="col-4 text-right">
                    <strong>{{
                      data.payment_mode_id == 13 ? "-" : currFormat(data.Refund)
                    }}</strong>
                  </div>
                  <div class="col-4 text-right">
                    <strong>{{ currFormat(data.final_total) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>Overall Summary</div>
      <header class="pos-schedule-header">
        <div
          class="col-lg-3 border-right h-100 d-flex align-items-center justify-content-start"
        >
          <strong>Payment Mode</strong>
        </div>
        <div class="col-lg-9">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="row schedule-header-titles">
                <div class="col-4 text-right">
                  <strong>Sale</strong>
                </div>
                <div class="col-4 text-right">
                  <strong>Refunded</strong>
                </div>
                <div class="col-4 text-right">
                  <strong>Total</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div class="row pos-user-collection">
        <div
          v-for="(data, dataIndex) in CollectionData"
          :key="dataIndex"
          :class="[
            'col-12 row',
            CollectionData.length - 1 !== dataIndex ? 'border-bottom' : '',
          ]"
        >
          <div
            class="col-lg-3 border-right h-100 d-flex align-items-center justify-content-start"
          >
            <strong>{{ data.payment_mode_name }}</strong>
          </div>
          <div class="col-lg-9">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <div class="row schedule-header-titles">
                  <div class="col-4 text-right">
                    <strong>{{ currFormat(data.total) || 0 }}</strong>
                  </div>
                  <div class="col-4 text-right">
                    <strong>{{
                      data.payment_mode_id == 13 ? "-" : currFormat(data.Refund)
                    }}</strong>
                  </div>
                  <div class="col-4 text-right">
                    <strong>{{ currFormat(data.final_total) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="pos-schedule-header">
        <div
          class="col-lg-3 border-right h-100 d-flex align-items-center justify-content-start"
        >
          <strong>Total</strong>
        </div>
        <div class="col-lg-9">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="row schedule-header-titles">
                <div class="col-4 text-right">
                  <strong>{{ currFormat(FinalTotal.total_amount) }}</strong>
                </div>
                <div class="col-4 text-right">
                  <strong>{{ currFormat(FinalTotal.total_refund) }}</strong>
                </div>
                <div class="col-4 text-right">
                  <strong>{{ currFormat(FinalTotal.total_collection) }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div
        class="w-100 text-center mt-5"
        v-if="CollectionData.length > 0"
      >
        <button class="btn btn-primary" @click="PrintPosUserCollection(true)">
          Print
        </button>
      </div>
    </div>
    <div v-else-if="status">
      <!-- <div class="userInfo mb-4">
        <div>User: {{ FinalTotal.user_name }}</div>
      </div> -->
      <div class="col-lg-12">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-6">
            <h4 class="h4_heading text-center">
              Welcome in {{ userData.company_name || "" }}
            </h4>
            <h4 class="h4_heading text-center">{{ userData.cine_name }}</h4>
            <h4 class="h4_heading text-center">{{ userData.vat_number }}</h4>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="user_data">
          <h5 class="h5_heading">Location: {{ userData.cine_location }}</h5>
          <h5 class="h5_heading">Station: 1234</h5>
          <h5 class="h5_heading"
            >Cashier: {{ userData.user_name }}-{{
              userData.up_empployee_code
            }}</h5
          >
          <h5 class="h5_heading">Session: S{{ userData.usl_id }}</h5>
        </div>
      </div>
      <div
        class="col-lg-12 d-flex justify-content-between align-items-center mt-2"
      >
        <h4 class="h4_heading">Sales</h4>
        <h4 class="h4_heading">{{ getCurrFromClientName() }}</h4>
        <h4 class="h4_heading">
          {{
            parseFloat(
              parseFloat(grandTotal.totalTransactionWithoutOfferRefund) +
                parseFloat(grandTotal.totalFnbWithoutOfferRefund) +
                parseFloat(grandTotal.totalAddonsWithoutRefund) +
                parseFloat(grandTotal.totalOfferRecords)
            ).toFixed(2) || 0.0
          }}
        </h4>
      </div>
      <h4 class="h4_heading text-center mt-2">***Department***</h4>
      <h4 class="h4_heading">Department Ticket</h4>
      <div class="col-lg-10">
        <table class="w-100" v-if="Records && Records.length > 0">
          <tr
            v-for="(record, recordIndex) in Records"
            :key="recordIndex + 'boxOfficeTicket'"
          >
            <td class="text-right">{{ record.total_seats }}</td>
            <td class="text-left pl-2">
              {{ record.movie_name }}
            </td>
            <td class="text-right pl-2"
              >{{ record.t_gross_amount }} {{ getCurrFromClientName() }}</td
            >
            <td class="text-right">{{ record.total_amount }}</td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left" colspan="3">Total</td>
            <td class="text-right">
              {{
                Records.reduce((acc, { total_amount }) => {
                  return parseFloat(
                    parseFloat(acc) + parseFloat(total_amount)
                  ).toFixed(2);
                }, 0)
              }}
            </td>
          </tr>
        </table>

        <h4 class="h4_heading mt-3">Department Addons</h4>
        <div class="col-lg-12">
          <table class="w-100" v-if="addonsRecords.length > 0">
            <tr
              v-for="(addonsRecords, addonsRecordsIndex) in addonsRecords"
              :key="addonsRecordsIndex + 'boxOfficeTicket'"
            >
              <td class="text-left pl-2">
                {{ addonsRecords.addons_name }}
              </td>

              <td class="text-right">{{ addonsRecords.add_ons_price }}</td>
            </tr>

            <tr class="font-weight-bold">
              <td class="text-left" colspan="1">Total</td>
              <td class="text-right">
                {{
                  addonsRecords.reduce((acc, { add_ons_price }) => {
                    return parseFloat(
                      parseFloat(acc) + parseFloat(add_ons_price)
                    ).toFixed(2);
                  }, 0)
                }}
              </td>
            </tr>
          </table>
        </div>

        <h4 class="h4_heading mt-2">Department F&B</h4>
        <table class="w-100" v-if="fnbRecords.length > 0">
          <tr
            v-for="(fnbRecord, fnbRecordIndex) in fnbRecords"
            :key="fnbRecordIndex + 'boxOfficeTicketFnB'"
          >
            <td class="text-right">{{ fnbRecord.total_quantity }}</td>
            <td class="text-left pl-2">
              {{ fnbRecord.fst_item_name }}
            </td>
            <td class="text-right pl-2"
              >{{ fnbRecord.fnb_price }} {{ getCurrFromClientName() }}</td
            >
            <td class="text-right">{{ fnbRecord.total_amount }}</td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left" colspan="3">Total</td>
            <td class="text-right">
              {{
                fnbRecords.reduce((acc, { total_amount }) => {
                  return parseFloat(
                    parseFloat(acc) + parseFloat(total_amount)
                  ).toFixed(2);
                }, 0)
              }}
            </td>
          </tr>
        </table>

        <h4 class="h4_heading mt-2">Department Promotion</h4>
        <table class="w-100" v-if="offerRecords.length > 0">
          <tr
            v-for="(offerRecord, offerRecordIndex) in offerRecords"
            :key="offerRecordIndex + 'boxOfficeTicketOffer'"
          >
            <td class="text-right">
              {{ offerRecord.total_seats || offerRecord.total_quantity || 0.0 }}
            </td>
            <td class="text-left pl-2">
              {{ offerRecord.fst_item_name || offerRecord.movie_name || 0.0 }}
              {{ offerRecord.offer_name || offerRecord.fst_offer_name || 0.0 }}
            </td>
            <td class="text-right pl-2">
              {{ offerRecord.t_gross_amount || offerRecord.fnb_price || 0.0 }}
              {{ getCurrFromClientName() }}
            </td>
            <td class="text-right">{{ offerRecord.total_amount }}</td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left" colspan="3">Total</td>
            <td class="text-right">
              {{
                offerRecords.reduce((acc, { total_amount }) => {
                  return parseFloat(
                    parseFloat(acc) + parseFloat(total_amount)
                  ).toFixed(2);
                }, 0)
              }}
            </td>
          </tr>
        </table>

        <h4 class="h4_heading mt-2">Department Refund</h4>
        <table class="w-100" v-if="refundRecords.length > 0">
          <tr
            v-for="(refundRecord, refundRecordIndex) in refundRecords"
            :key="refundRecordIndex + 'boxOfficeTicketOffer'"
          >
            <td class="text-right">
              {{
                refundRecord.total_seats || refundRecord.total_quantity || 0.0
              }}
            </td>
            <td class="text-left pl-2">
              {{ refundRecord.fst_item_name || refundRecord.movie_name || 0.0 }}
            </td>
            <td class="text-right pl-2">
              {{ refundRecord.t_gross_amount || refundRecord.fnb_price || 0.0 }}
              {{ getCurrFromClientName() }}
            </td>
            <td class="text-right">{{ refundRecord.total_amount }}</td>
          </tr>
          <tr>
            <td class="text-left" colspan="3">Total</td>
            <td class="text-right">
              {{
                refundRecords.reduce((acc, { total_amount }) => {
                  return parseFloat(
                    parseFloat(acc) + parseFloat(total_amount)
                  ).toFixed(2);
                }, 0)
              }}
            </td>
          </tr>
        </table>

        <h4 class="h4_heading mt-3">Department Refund Addons</h4>
        <div class="col-lg-12">
          <table class="w-100" v-if="addonsRefundRecords.length > 0">
            <tr
              v-for="(addonsRefundRecords,
              addonsRefundIndex) in addonsRefundRecords"
              :key="addonsRefundIndex + 'boxOfficeTicket'"
            >
              <td class="text-left pl-2">
                {{ addonsRefundRecords.addons_name }}
              </td>

              <td class="text-right">
                {{ addonsRefundRecords.add_ons_price }}
              </td>
            </tr>

            <tr class="font-weight-bold">
              <td class="text-left" colspan="1">Total</td>
              <td class="text-right">
                {{
                  addonsRefundRecords.reduce((acc, { add_ons_price }) => {
                    return parseFloat(
                      parseFloat(acc) + parseFloat(add_ons_price)
                    ).toFixed(2);
                  }, 0)
                }}
              </td>
            </tr>
          </table>
        </div>

        <table class="w-100 mt-3">
          <tr>
            <td colspan="3" class="font-weight-bold">Total</td>
            <td></td>
            <td></td>
            <td>
              {{
                parseFloat(
                  parseFloat(grandTotal.totalTransactionWithoutOfferRefund) +
                    parseFloat(grandTotal.totalFnbWithoutOfferRefund) +
                    parseFloat(grandTotal.totalAddonsWithoutRefund) +
                    parseFloat(grandTotal.totalOfferRecords)
                ).toFixed(2) || 0.0
              }}
            </td>
          </tr>
          <!-- <tr>
            <td colspan="3">Vat</td>
            <td>
              {{
                parseFloat(
                  parseFloat(grandTotal.total_vat) +
                    parseFloat(grandTotal.fnbTotalVat)
                ).toFixed(2) || 0.0
              }}
            </td>
          </tr> -->
        </table>
      </div>

      <div
        class="w-100 text-center mt-5"
        v-if="combinedValidationArr.length > 0"
      >
        <button
          class="btn btn-primary"
          @click="printShiftCloseSummaryInvoice(true)"
        >
          Print
        </button>
        <!-- PrintPosUserCollection(true)  -->
      </div>
    </div>
    <div class="no-data" v-else>
      <p>No Transaction Found</p>
    </div>
    <div ref="onPrint" class="">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>

<script>
  import Datepicker from "vuejs-datepicker";
  import moment from "moment";
  import PosService from "@/services/PosService.js";
  import _ from "lodash";
  import Printd from "printd";
  import { createQueryString } from "@/services/ApiHelper";
  import { CLIENT_NAME } from "@/helper/Role";
  import { BASEURL } from "@/config/index";

  export default {
    props: {
      childComponents: {
        type: Object,
      },
      onClickHandler: { type: Function },
    },
    components: {
      Datepicker,
    },

    data() {
      return {
        noAuth: false,
        CollectionData: [],
        FinalTotal: {},
        from_date: "",
        to_date: "",
        show_current_shift_collection: "N",
        LoggedUserId: null,
        dateDisable: false,
        EjsData: null,
        userData: {},
        Records: [],
        offerRecords: [],
        refundRecords: [],
        fnbRecords: [],
        fnbOfferRecords: [],
        addonsRecords: [],
        addonsRefundRecords: [],
        fnbRefundRecords: [],
        grandTotal: {},
        status: false,
        combinedValidationArr: [],
      };
    },
    computed: {},
    beforeMount() {
      const { user_id, cinema_id } = this.secureStore.get("USINFO");
      //   this.printShiftCloseSummaryInvoice(true)
      // }
      this.LoggedUserId = user_id;
      this.from_date = moment().format("YYYY-MM-DD HH:mm:ss");
      this.to_date = moment().format("YYYY-MM-DD HH:mm:ss");

      // this.printShiftCloseSummaryInvoice(true);
      this.getShiftCloseInvoice(false);
      // this.getPosUserCollection();
    },
    mounted() {},
    methods: {
      getCurrFromClientName() {
        if (!this.CLIENT_SETUP_NAME) return "";

        if (String(this.CLIENT_SETUP_NAME).toUpperCase() == "IRAQ")
          return "IQD";
        if (String(this.CLIENT_SETUP_NAME).toUpperCase() == "EMPIRE")
          return "SAR";

        return "";
      },
      printShiftCloseSummaryInvoice(isPrint = true) {
        let payload = {
          user_id: this.LoggedUserId,
          fromDate: moment(this.from_date || new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          toDate: moment(this.to_date || new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          isCurrentShift: this.show_current_shift_collection,
          isPrint: isPrint,
        };

        PosService.getShiftCloseInvoiceSummary(payload)
          .then((response) => {
            const { data } = response;
            // if (data.ejsTicket) {
            if (
              this.show_current_shift_collection == "N" &&
              (!this.from_date || !this.to_date)
            ) {
              return this.$toasted.show("Please Select Dates");
            } else {
              var userAgent = navigator.userAgent.toLowerCase();
              if (userAgent.indexOf(" electron/") > -1) {
                let loader = this.$loading.show();
                // try {
                const queryString = createQueryString(payload);
                console.log(this.$socket, "socket");
                if (this.$socket && isPrint) {
                  console.log("socket_close_invoked");
                  this.$socket.emit("on_print_ticket", {
                    baseurl: BASEURL,
                    ttype: "pos_collection_summary",
                    user_id: this.LoggedUserId,
                    queryString: queryString,
                  });
                  console.log("socket_close_invoked_123");
                }
                console.log("outside_socket");
                loader.hide();
                // } catch (err) {
                //   console.log("ERROR in SOcket", err);
                // } finally {
                //   setTimeout(() => loader.hide(), 1000);
                // }
              }
            }
            // }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      getShiftCloseInvoice(isPrint = false) {
        console.log('CLIENT_NAME.BILDHAUS.toLowerCase()', CLIENT_NAME.BILDHAUS.toLowerCase());
        console.log('this.CLIENT_SETUP_NAME.toLowerCase()', this.CLIENT_SETUP_NAME.toLowerCase());
        if(CLIENT_NAME.BILDHAUS.toLowerCase() == this.CLIENT_SETUP_NAME.toLowerCase()) {
          this.getPosUserCollection()
        } else {
          this.getShiftCloseInvoiceFunc(isPrint)
        }
      },
      getShiftCloseInvoiceFunc(isPrint = false) {
        let loader = this.$loading.show();
        let payload = {
          user_id: this.LoggedUserId,
          fromDate: moment(this.from_date || new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          toDate: moment(this.to_date || new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          isCurrentShift: this.show_current_shift_collection,
          isPrint: isPrint,
        };

        PosService.getShiftCloseInvoiceSummary(payload)
          .then((response) => {
            const { data, status } = response;
            if (status) {
              this.status = data.status;
              this.userData = { ...data.UserShift[0] };
              this.Records = [...data.Records];
              this.offerRecords = [
                ...data.offerRecords,
                ...data.fnbOfferRecords,
              ];
              this.refundRecords = [
                ...data.refundRecords,
                ...data.fnbRefundRecords,
              ];
              this.addonsRefundRecords = [...data.addOnsRefunded];
              this.addonsRecords = [...data.addOns];
              this.fnbRecords = [...data.fnbRecords];
              this.fnbOfferRecords = [...data.fnbOfferRecords];
              this.fnbRefundRecords = [...data.fnbRefundRecords];
              this.grandTotal = { ...data.grandTotal[0] };
              this.EjsData = data.ejsTicket;
              this.combinedValidationArr = [
                this.Records,
                this.offerRecords,
                this.fnbRecords,
                this.refundRecords,
                this.addonsRefundRecords,
                this.addonsRecords,
                this.fnbOfferRecords,
                this.fnbRefundRecords,
              ];

              if (this.EjsData && isPrint) {
                this.$nextTick(() => {
                  loader.hide();
                  const p = new Printd();
                  if (this.$refs.onPrint && this.EjsData != null) {
                    p.print(this.$refs.onPrint, []);
                  }
                });
              }
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onChangeDate: _.debounce(function() {
        if (
          moment(this.from_date).format("YYYY-MM-DD") >
          moment(this.to_date).format("YYYY-MM-DD")
        ) {
          this.$toasted.show("From date must be smaller than to date!");
        } else {
          this.getShiftCloseInvoice();
        }
      }, 1.5 * 1000),
      OnSwitchChange(event) {
        this.show_current_shift_collection = event;
        if (event == "Y") {
          this.from_date = "";
          this.to_date = "";
          this.dateDisable = true;
        } else {
          this.from_date = moment().format("YYYY-MM-DD");
          this.to_date = moment().format("YYYY-MM-DD");
          this.dateDisable = false;
        }
        this.getShiftCloseInvoice();
      },
      PrintPosUserCollection(isPrint = true) {
        let payload = {
          from_date: this.from_date
            ? moment(this.from_date).format("YYYY-MM-DD HH:mm:ss")
            : "",
          to_date: this.to_date
            ? moment(this.to_date).format("YYYY-MM-DD HH:mm:ss")
            : "",
          show_current_shift_collection: this.show_current_shift_collection,
          user_id: this.LoggedUserId,
          isPrint: isPrint,
        };

        if (
          this.show_current_shift_collection == "N" &&
          (!this.from_date || !this.to_date)
        ) {
          return this.$toasted.show("Please Select Dates");
        } else {
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf("electron/") > -1) {
            let loader = this.$loading.show();
            try {
              const queryString = createQueryString(payload);
              if (this.$socket) {
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "pos_collection_summary",
                  user_id: this.LoggedUserId,
                  queryString: queryString,
                });
              }
            } catch (err) {
              console.log("ERROR in Socket", err);
            } finally {
              setTimeout(() => loader.hide(), 1000);
            }
          } else {
            this.getPosUserCollection(true);
          }
        }
      },
      getPosUserCollection(isPrint = false) {
        let payload = {
          from_date: this.from_date
            ? moment(this.from_date).format("YYYY-MM-DD")
            : "",
          to_date: this.to_date
            ? moment(this.to_date).format("YYYY-MM-DD")
            : "",
          show_current_shift_collection: this.show_current_shift_collection,
          user_id: this.LoggedUserId,
          isPrint: isPrint,
        };
        if (
          this.show_current_shift_collection == "N" &&
          (!this.from_date || !this.to_date)
        ) {
          return this.$toasted.show("Please Select Dates");
        } else {
          let loader = this.$loading.show();
          PosService.getPosUserCollection(payload)
            .then((response) => {
              const { data } = response;
              if (data.status && !isPrint) {
                if (!isPrint) {
                  this.CollectionData = data.Records;
                  this.FinalTotal = data.FinalCollection;
                }
              } else if (isPrint) {
                this.EjsData = data;

                this.$nextTick(() => {
                  loader.hide();
                  const p = new Printd();
                  if (this.$refs.onPrint && this.EjsData != null) {
                    p.print(this.$refs.onPrint, []);
                  }
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      },
      closeModalSection: function() {
        this.onClickHandler("posUserCollection");
      },
    },
  };
</script>

<style>
  #line-progress {
    border-radius: 7px;
  }
  .pos-user-collection strong {
    line-height: 55px;
  }
  .posUserCollection-title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 42px;
  }
  .no-data {
    text-align: center;
    font-size: 17px;
    margin-top: 130px;
  }
  .userInfo {
    font-weight: 500;
    font-size: 22px;
  }
  .pos-user-collection-wrapper {
    font-size: 20px;
  }
  .h4_heading,
  .h5_heading {
    font-size: 14px;
    font-weight: 800;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posUserCollection.vue